import { RootState } from '../types'

export const getMainWorkerSelector = (state: RootState) => state.specialist
